import { jsx } from "react/jsx-runtime";
import { FourCornersCategory } from "./AdViews/view.fourCornersCategory.js";
import { HalfBanner } from "./AdViews/view.half.js";
import { OneFourth } from "./AdViews/view.oneFourth.js";
import { OneFourthMix } from "./AdViews/view.oneFourthMix.js";
import { OneSixth } from "./AdViews/view.oneSixth.js";
import { OneThird } from "./AdViews/view.oneThird.js";
import { AD_TYPE_ONE_THIRD, AD_TYPE_ONE_SIXTH, AD_TYPE_ONE_FOURTH_MIX, AD_TYPE_ONE_FOURTH, AD_TYPE_HALF, AD_TYPE_FULL, AD_TYPE_FOUR_CORNERS_CATEGORY } from "./constants.js";
const COMPONENT_MAP = {
  [AD_TYPE_FOUR_CORNERS_CATEGORY]: FourCornersCategory,
  [AD_TYPE_FULL]: null,
  [AD_TYPE_HALF]: HalfBanner,
  [AD_TYPE_ONE_FOURTH]: OneFourth,
  [AD_TYPE_ONE_FOURTH_MIX]: OneFourthMix,
  [AD_TYPE_ONE_SIXTH]: OneSixth,
  [AD_TYPE_ONE_THIRD]: OneThird
};
const AdButlerBannerComposer = ({
  componentType,
  children
}) => {
  const Component = COMPONENT_MAP[componentType];
  if (!Component) {
    return children;
  }
  return /* @__PURE__ */ jsx(Component, { children });
};
export {
  AdButlerBannerComposer
};
